import React from 'react';
import doubleLogoSowos from "../images/double-logo-sowos.svg"
import togetherWealthImage from "../images/together-wealth.svg"

export default function TogetherSection(props) {
    return (
        <div className="together-container pb-5 pt-5 bg-light-grey">
        <h2 className="together-title text-secondary text-center mb-4 fw-bold pt-5">{props.title}</h2>
        <div className="double-logo-container d-flex justify-content-center mb-5">
          <img
            className="double-logo-sowos"
            src={doubleLogoSowos}
            alt="Imagen de dos logos de sowos juntos."
          />
        </div>
        <div className="d-flex justify-content-center">
          <img
            className="img-fluid"
            src={togetherWealthImage}
            alt="Imagen de varias personas juntos."
          />
        </div>
      </div>
    );
}